import React, { Component } from 'react'

import ContentLoader from 'react-content-loader'

export default class ConfigLoader extends Component {
  render() {
    return (
      <ContentLoader
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        height={180}
      >
        <rect x={0} y={0} rx="1" ry="1" width={50} height="10" />
        <rect x={0} y={15} rx="1" ry="1" width={70} height="6" />

        <rect x={0} y={35} rx="1" ry="1" width={50} height="10" />
        <rect x={0} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={40} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={85} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={130} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={175} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={220} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={265} y={50} rx="1" ry="1" width={35} height={8} />
        <rect x={0} y={65} rx="1" ry="1" width={400} height={20} />

        <rect x={0} y={100} rx="1" ry="1" width={50} height="10" />
        <rect x={0} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={40} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={85} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={130} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={175} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={220} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={265} y={125} rx="1" ry="1" width={35} height={8} />
        <rect x={0} y={140} rx="1" ry="1" width={400} height={20} />

      </ContentLoader>
    )
  }
}
